module.exports = "//cdn.scentbird.com/assets/frontbird-site/images/invite_female_fb02cf.gif";